var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('u-button',_vm._g({staticClass:"add-to-cart-button",attrs:{"kind":_vm.buttonType,"icon-name":_vm.iconName,"disabled":_vm.disabled}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t(_vm.addToCartButtonLabel)))])}
var staticRenderFns = []

export { render, staticRenderFns }